import React from 'react';
import { useLocation } from 'react-router';
import { BRAND, TEAM, TIMELINE, STATS } from '../mock/mockData.js';

export default function About() {
  const { pathname } = useLocation();
  const isAppMode = pathname === '/about-app';
  return (
    <>
      <section style={{ background:'linear-gradient(135deg,#1F1535,#5B21B6)', padding:'5rem 0 4rem', textAlign:'center' }}>
        <div className="ctr">
          <span className="eyebrow" style={{ background:'rgba(255,255,255,.12)', color:'rgba(255,255,255,.9)' }}>Our story</span>
          <h1 className="display" style={{ color:'white', margin:'1rem 0', fontSize:'clamp(1.8rem,4vw,3.4rem)' }}>
            Built for <span style={{ color:'#F59E0B' }}> Atmanirbhar Bharat...!</span>
          </h1>
          <p style={{ color:'rgba(255,255,255,.7)', fontSize:'clamp(1rem, 1.05rem, 1.05rem)', maxWidth:540, margin:'0 auto', lineHeight:1.7 }}>
           A team of IT engineers and Food industry experts on a mission to put world-class POS technology in every Indian restaurant and hotel at a price that makes sense.
          </p>
        </div>
      </section>

      <section style={{ background:'white', padding:'3rem 0', borderBottom:'1px solid var(--border)' }}>
        <div className="ctr">
          <div className="g4">
            {STATS.map(s => (
              <div key={s.label} style={{ textAlign:'center' }}>
                <div className="stat-val">{s.value}</div>
                <div className="stat-lbl">{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="sec">
        <div className="ctr">
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:'4rem', alignItems:'center', '@media (max-width: 768px)': { gridTemplateColumns:'1fr', gap:'2.5rem' } }}>
            <div>
              <span className="eyebrow">Our mission</span>
              <h2 className="htitle" style={{ marginBottom:'1.25rem' }}>Empowering every merchant, everywhere in India</h2>
              <p style={{ color:'var(--text2)', lineHeight:1.8, marginBottom:'1rem', fontSize:'clamp(.95rem, 1rem, 1rem)' }}>India has over 7 million restaurants and 1.5 million hotels. Most still run on paper bills or outdated software that was never built for their needs.</p>
              <p style={{ color:'var(--text2)', lineHeight:1.8, marginBottom:'1rem', fontSize:'clamp(.95rem, 1rem, 1rem)' }}>TotalPe was founded in 2023 by a team that spent years seeing this problem first-hand working inside kitchens, hotels, and fintech companies.</p>
              <p style={{ color:'var(--text2)', lineHeight:1.8, fontSize:'clamp(.95rem, 1rem, 1rem)' }}>Headquartered in Pimpri-Chinchwad, Maharashtra right in the market we serve we are proud to be a deeply Indian product built for Indian connectivity, languages and GST compliance.</p>
            </div>
             <div className="imgph" style={{ overflow:'hidden', display:'flex', alignItems:'center', justifyContent:'center', minHeight:'380px', borderRadius:'var(--r-lg)' }}>
                <img src="/assets/totalpe-og-1200x630.png" alt="TotalPe" style={{ width:'100%', height:'100%', objectFit:'contain'}}/>
              </div>
          </div>
        </div>
      </section>

      {/* <section className="sec sec-alt">
        <div className="ctr" style={{ maxWidth:680 }}>
          <div style={{ textAlign:'center', marginBottom:'3rem' }}>
            <span className="eyebrow">Our journey</span>
            <h2 className="htitle">From garage to 50,000 merchants</h2>
          </div>
          {TIMELINE.map((t, i) => (
            <div key={t.year} style={{ display:'flex', gap:'1.5rem', marginBottom: i < TIMELINE.length - 1 ? '2rem' : 0 }}>
              <div style={{ display:'flex', flexDirection:'column', alignItems:'center' }}>
                <div style={{ background:'var(--vivid)', color:'white', fontWeight:800, fontSize:'.9rem', padding:'5px 14px', borderRadius:'var(--r-full)', whiteSpace:'nowrap' }}>{t.year}</div>
                {i < TIMELINE.length - 1 && <div style={{ width:2, flex:1, background:'var(--tint)', marginTop:8 }} />}
              </div>
              <p style={{ color:'var(--text2)', lineHeight:1.7, marginTop:6, paddingBottom: i < TIMELINE.length - 1 ? '1.5rem' : 0 }}>{t.event}</p>
            </div>
          ))}
        </div>
      </section> 

      <section className="sec">
        <div className="ctr">
          <div style={{ textAlign:'center', marginBottom:'3rem' }}>
            <span className="eyebrow">The team</span>
            <h2 className="htitle">People who eat, breathe and ship</h2>
          </div>
          <div className="g4">
            {TEAM.map(m => (
              <div key={m.name} className="card" style={{ textAlign:'center' }}>
                <div style={{ width:68, height:68, borderRadius:'50%', background:'var(--tint)', display:'flex', alignItems:'center', justifyContent:'center', fontWeight:800, fontSize:'1.2rem', color:'var(--primary)', margin:'0 auto 1rem' }}>{m.avatar}</div>
                <h3 style={{ fontWeight:700, marginBottom:2 }}>{m.name}</h3>
                <p style={{ fontSize:'.8rem', color:'var(--vivid)', fontWeight:600, marginBottom:'.75rem' }}>{m.role}</p>
                <p style={{ fontSize:'.85rem', color:'var(--text2)', lineHeight:1.6 }}>{m.bio}</p>
              </div>
            ))}
          </div>
        </div>
      </section>*/}

      <section className="sec sec-alt">
        <div className="ctr" style={{ maxWidth:580, textAlign:'center' }}>
          <span className="eyebrow">Get in touch</span>
          <h2 className="htitle" style={{ marginBottom:'1rem' }}>We love hearing from merchants</h2>
          <p style={{ color:'var(--text2)', marginBottom:'2rem', fontSize:'clamp(.95rem, 1rem, 1rem)', lineHeight:1.7 }}>Questions, feedback, partnership proposals — our team reads every message and responds within 24 hours.</p>
          <div style={{ display:'flex', gap:'1rem', justifyContent:'center', flexWrap:'wrap', flexDirection:'row', '@media (max-width: 480px)': { flexDirection:'column', gap:'0.75rem' } }}>
            <a href={`mailto:${BRAND.email}`} className="btn btn-p btn-lg" style={{ '@media (max-width: 480px)': { width:'100%', justifyContent:'center' } }}>✉ {BRAND.email}</a>
            <a href={`tel:${BRAND.phone}`}    className="btn btn-o btn-lg" style={{ '@media (max-width: 480px)': { width:'100%', justifyContent:'center' } }}>📞 {BRAND.phone}</a>
          </div>
          <p style={{ marginTop:'2rem', fontSize:'clamp(.8rem, .85rem, .85rem)', color:'var(--text3)', lineHeight:1.6 }}>{BRAND.address}</p>
        </div>
      </section>
    </>
  );
}